import React from 'react';
import { connect } from 'react-redux';
import { ConfigService, withInject } from '@piwikpro/platform';
import { Organization } from '@piwikpro/organization-crate';
import {
  SplashScreen,
  View,
  Root,
  Preloader,
  JWTProvider,
} from '@piwikpro/ui-components';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { Session } from '@piwikpro/auth-crate/Session';

const mapStateToProps = (state: any) => ({
  defaultModuleId: state.session.defaultModuleId,
  userId: state.session.userId,
  jwt: state.session.jwt,
});

interface Props {
  organization: Organization
  defaultModuleId: string
  config: ConfigService
  userId: string
  jwt: SessionState['jwt']
  ProductBar: typeof React.Component
  sessionService: Session
}

class DefaultModuleRedirector extends React.Component<Props> {
  async componentDidMount() {
    const {
      organization,
      defaultModuleId,
      config,
      userId,
    } = this.props;
    let redirectUrl;

    if (defaultModuleId === null) return;

    try {
      const {
        data: {
          attributes: {
            apps,
            common,
          },
        },
      } = await organization.fetchConfig(userId);

      redirectUrl = [...apps, ...common]!.find(
        element => element.id === defaultModuleId,
      )?.href;
    } catch (err) {
      redirectUrl = config.get('DEFAULT_MODULE_URL_FALLBACK');
    }

    document.location.replace(`${document.location.origin}${redirectUrl}`);
  }

  render() {
    const {
      defaultModuleId,
      ProductBar,
      jwt,
      sessionService,
    } = this.props;

    if (defaultModuleId === null) {
      return (
        <JWTProvider jwt={jwt!} refreshJWT={sessionService.refreshJWT}>
          <Root withThemes>
            <Root.TopSection>
              <ProductBar />
            </Root.TopSection>
            <View fullHeight>
              <SplashScreen type="noPrivilegesAllModules" />
            </View>
          </Root>
        </JWTProvider>
      );
    }

    return <Preloader />;
  }
}

export default withInject({
  organization: 'OrganizationCrate.organization',
  ProductBar: 'AuthCrate.components.ProductBar',
  config: 'config',
  sessionService: 'AuthCrate.session',
})(connect(mapStateToProps, null)(DefaultModuleRedirector));
